// Hardware Register taxonomy — categories, subtypes (per category) and brands (per category).
// Keep the value keys stable; labels can be freely reworded.

export const CATEGORIES = [
  {
    value: "computer",
    label: "Computer & User Devices",
    subtypes: [
      "Desktop Computer", "Laptop", "All-in-One Computer", "Workstation", "Mini PC", "Thin Client",
      "Tablet", "Monitor", "Touchscreen Monitor", "Keyboard", "Mouse", "Wireless Keyboard",
      "Wireless Mouse", "Webcam", "Headset", "Speakers", "Microphone",
    ],
    brands: [
      "Dell", "HP", "Lenovo", "Acer", "ASUS", "Apple", "MSI", "Samsung", "LG", "Toshiba",
      "Fujitsu", "HCL", "Wipro", "iBall", "Microsoft", "Intel", "AMD", "Other",
    ],
  },
  {
    value: "power",
    label: "Power Equipment",
    subtypes: [
      "UPS", "Inverter", "Battery", "Power Bank", "Voltage Stabilizer", "Surge Protector",
      "Extension Board", "Power Adapter", "Laptop Charger", "Desktop SMPS",
    ],
    brands: [
      "APC", "Microtek", "Numeric", "Luminous", "Exide", "Amaron", "Emerson / Vertiv", "Eaton",
      "V-Guard", "Su-Kam", "Delta", "CyberPower", "Zebronics", "HYKON", "Other",
    ],
  },
  {
    value: "printing",
    label: "Printing & Scanning",
    subtypes: [
      "Printer", "Laser Printer", "Inkjet Printer", "Multifunction Printer", "Dot Matrix Printer",
      "Barcode Printer", "Label Printer", "Scanner", "Barcode Scanner", "Document Scanner",
      "Photocopier / Copier",
    ],
    brands: [
      "HP", "Canon", "Epson", "Brother", "Xerox", "Ricoh", "Kyocera", "Konica Minolta",
      "Samsung", "Pantum", "TVS", "TSC", "Zebra", "Other",
    ],
  },
  {
    value: "networking",
    label: "Networking Equipment",
    subtypes: [
      "Router", "Wi-Fi Router", "Wireless Access Point", "Network Switch", "Managed Switch",
      "Modem", "Firewall", "Network Rack", "Patch Panel", "LAN Cable", "Network Cable",
      "Ethernet Adapter", "Wi-Fi Adapter", "Network Card", "SFP Module", "Media Converter",
    ],
    brands: [
      "Cisco", "TP-Link", "D-Link", "Netgear", "Ubiquiti", "MikroTik", "Aruba", "Juniper",
      "Fortinet", "Huawei", "Linksys", "Ruijie", "Tenda", "Other",
    ],
  },
  {
    value: "storage",
    label: "Servers & Storage",
    subtypes: [
      "Server", "NAS (Network Attached Storage)", "External Hard Disk", "Internal Hard Disk",
      "SSD", "External SSD", "USB Flash Drive / Pen Drive", "Memory Card", "Card Reader",
      "Backup Drive", "RAID Storage",
    ],
    brands: [
      "Seagate", "Western Digital (WD)", "Samsung", "Kingston", "SanDisk", "Crucial", "Toshiba",
      "Transcend", "ADATA", "HP", "Dell", "Synology", "QNAP", "Other",
    ],
  },
  {
    value: "communication",
    label: "Office & Communication",
    subtypes: [
      "Landline Telephone", "IP Phone", "Intercom", "EPABX System", "Conference Speakerphone",
      "Video Conferencing System", "Projector", "Projector Screen", "Smart TV", "Digital Display",
      "Digital Signage",
    ],
    brands: [
      "Cisco", "Poly", "Yealink", "Grandstream", "Panasonic", "Avaya", "NEC", "Matrix",
      "Beetel", "Motorola", "Logitech", "Jabra", "Other",
    ],
  },
  {
    value: "security",
    label: "Security & Surveillance",
    subtypes: [
      "CCTV Camera", "PTZ Camera", "DVR", "NVR", "Biometric Attendance Device", "Fingerprint Scanner",
      "Face Recognition Device", "Access Control System", "RFID Reader", "RFID Card",
      "Door Controller", "Security Alarm",
    ],
    brands: [
      "Hikvision", "CP Plus", "Dahua", "Honeywell", "Bosch", "Axis", "ZKTeco", "eSSL", "Suprema",
      "Godrej", "Panasonic", "Secureye", "Prama", "Other",
    ],
  },
  {
    value: "accessories",
    label: "Other IT Accessories",
    subtypes: [
      "USB Hub", "Docking Station", "HDMI Cable", "VGA Cable", "DisplayPort Cable", "USB Cable",
      "HDMI Adapter", "VGA Adapter", "Bluetooth Adapter", "Laptop Stand", "Monitor Stand",
      "Cooling Pad", "Optical Drive", "Graphics Card", "RAM Module", "Motherboard", "Processor / CPU",
    ],
    brands: [
      "Logitech", "Microsoft", "Dell", "HP", "Lenovo", "Zebronics", "Portronics", "Lapcare",
      "TVS", "iBall", "Belkin", "Anker", "UGREEN", "Other",
    ],
  },
  {
    value: "other",
    label: "Other",
    subtypes: ["Other (Specify)"],
    brands: ["Generic / Unbranded", "Local Brand", "OEM", "Other (Specify)"],
  },
];

export const INSTITUTION_TYPES = [
  { value: "local_body", label: "Local Body" },
  { value: "other_office", label: "Other Office" },
];

export function getCategory(value) {
  return CATEGORIES.find(c => c.value === value) || null;
}
